import vmClient from 'app/services/vmClient';
import { UserProfile, IUserProfile } from 'app/constants/schemas/UserProfile';
import {
  Entity,
  IEntityType,
  IEntity,
  EntityStringId,
} from 'app/types/entity';
import { Map, MapMarshaller } from 'app/constants/schemas/Map';

export interface IParticipant extends IEntity {
  attributes: {
    id: EntityStringId;
    anonymousName: string | null;
    anonymousNameRank: number | null;
    appData: Map<string, any> | null;
  },
  associations: {
    user: IUserProfile | null;
  };
}

export type Participant = Entity<IParticipant>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Participant: IEntityType<IParticipant> = vmClient.defineClass({
  typeName: 'Rtc.Participant',
  version:  2,
  persisted: true,

  attributes: {
    id: { type: 'string', notNull: true },
    anonymousName: { type: 'string' },
    anonymousNameRank: { type: 'number' },
    appData: {
      type: Map,
      marshaller: MapMarshaller,
    },
  },

  associations: {
    user: {
      type:   UserProfile,
      shared: true,
    },
  },
});

export interface IRecordizedParticipant extends IEntity {
  attributes: {
    id: EntityStringId;
    anonymousName: string | null;
    anonymousNameRank: number | null;
    appData: Map<string, any> | null;
  },
  nestedAssociations: {
    user: UserProfile | null;
  };
}

export type RecordizedParticipant = Entity<IRecordizedParticipant>;
// RecordizedParticipant is a class.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RecordizedParticipant = Participant as unknown as IEntityType<IRecordizedParticipant>;
